




































































































































































































































































































































































import { defineComponent, computed } from '@nuxtjs/composition-api'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { useDep } from '~/compositions/dependency-container'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { useNamespacedStore } from '~/compositions/store'
import { APP_NS } from '~/store/modules/shared/app/state'

export default defineComponent({
  components: { CImg, CCard },
  setup() {
    const { getters } = useNamespacedStore(APP_NS)
    const isPlot = computed(() => getters('isPlot'))

    const legacyUrlService = useDep(LegacyUrlService)
    const creditsUrl = computed(() => {
      return legacyUrlService.getBuyCreditsUrl()
    })

    const translations: any = {
      stepOne: {
        el: `
      Aν θες να εκτοξεύσεις την επισκεψιμότητα της αγγελίας σου
      έως και 700%, τότε το μόνο που έχεις να κάνεις είναι να επιλέξεις
      το εργαλείο προώθησης αγγελιών που θα βρεις στη κάθε αγγελία
      ξεχωριστά. Μπες στην Αγγελία σου, Επίλεξε πακέτο προώθησης και
      ξεκίνα.
      `,
        en: `
      If you want to increase your ad traffic by up to 700%, then all you
      have to do is choose the ad promotion tool that you will find in each
      ad separately. Go to your ad, choose a promotion package and start.
      `
      },
      stepTwo: {
        first: {
          el: `
        Με την ανανέωση της αγγελίας φέρνεις την αγγελία σου πρώτη στο
        σύνολο των αγγελιών και έτσι για το προσεχές διάστημα ο επισκέπτης
        του Car.gr θα σε βρίσκει στα πρώτα αποτελέσματα της αναζήτησης
        του.
        `,
          en: `
        Bring your ad first to a set of ads, by renewing the ad, so for
        the next period the visitor of Car.gr will find you in the first
        search results.
        `
        },
        second: {
          el: `
        Για εσένα που θες να προγραμματίσεις τις ανανεώσεις σου,
        δημιουργήσαμε το εργαλείο προγραμματισμού και έτσι απλά μπαίνεις
        σε μια αγγελία σου ορίζεις την ημέρα και ώρα που θες να γίνεται
        η ανανέωση της και αυτή θα πραγματοποιείται αυτόματα.
          `,
          en: `
        For those of you who want to plan your renewals,
        we created the scheduling tool, so you simply enter an ad,
        set the day and time you want the renewal to take place and
        from there on it will be done automatically.
          `
        }
      },
      buyCredits: {
        el: `
        Για να χρησιμοποιήσεις τις λειτουργίες της αυτόματης ανανέωσης και προώθησης
        θα χρειαστεί να έχεις στο λογαριασμό σου διαθέσιμο υπόλοιπο "credits". Τα "credits"
        είναι εικονικά νομίσματα τα οποία μπορείς να αγοράσεις απευθείας από
        <strong><a href=${creditsUrl.value} target="blank" class="tw-text-white hover:tw-text-white">εδώ</a></strong>.
        Πιστώνονται άμεσα στο λογαριασμό σου και μπορείς να τα χρησιμοποιήσεις σε οποιαδήποτε ενέργεια προώθησης
        επιθυμείς.
        `,
        en: `
        To use the automatic renewal and promotion features,
        you will need to have a balance of "credits" available in your account. "Credits"
        are virtual coins that you can buy directly from
        <strong><a href=${creditsUrl.value} target="blank" class="tw-text-white hover:tw-text-white">here</a></strong>.
        They are credited directly to your account, and you can use them in any promotional action you wish.
        `
      },
      stepFour: {
        el: `
        Η φωτογραφία είναι το πάν, γι'αυτό φρόντισε να βγάλεις σωστές φωτογραφίες όπως ο Κώστας σε αυτό το video.
        `,
        en: `
        Photography is everything, so make sure you take the right photos like Kostas in this video.
        `,
        plot: {
          el: `
        Η φωτογραφία είναι το πάν, γι'αυτό φρόντισε να βγάλεις σωστές φωτογραφίες.
        `,
          en: `
        Photography is everything, so make sure you take the right photos.
        `
        }
      }
    }

    return { translations, creditsUrl, isPlot }
  }
})
